import ChatbotButton from './ChatbotButton';

globalThis.ChatbotButton = {
  ChatbotButton,
};
